/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse
 */
export interface JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse
     */
    isMFAEnforced?: boolean;
}

/**
 * Check if a given object implements the JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse interface.
 */
export function instanceOfJumboGetorgmfaenforcedGetOrgMFAEnforcedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetorgmfaenforcedGetOrgMFAEnforcedResponseFromJSON(json: any): JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse {
    return JumboGetorgmfaenforcedGetOrgMFAEnforcedResponseFromJSONTyped(json, false);
}

export function JumboGetorgmfaenforcedGetOrgMFAEnforcedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isMFAEnforced': !exists(json, 'isMFAEnforced') ? undefined : json['isMFAEnforced'],
    };
}

export function JumboGetorgmfaenforcedGetOrgMFAEnforcedResponseToJSON(value?: JumboGetorgmfaenforcedGetOrgMFAEnforcedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isMFAEnforced': value.isMFAEnforced,
    };
}

